import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-green-600 border border-green-600 my-[10px] text-white text-center fixed top-[30px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[550px] w-[90%] p-[20px]"
}
const _hoisted_2 = {
  key: 1,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed top-[30px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[550px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "font-montserrat flex justify-center items-center relative min-w-screen min-h-screen py-[50px] px-[10px] bg-gray-50" }
const _hoisted_4 = { class: "w-full flex justify-center items-center flex-col relative py-[50px] md:px-[20px] px-[10px] max-w-[600px] border-2 border-gray-300 h-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl mb-[20px] text-center font-bold" }, "Réinitialiser votre mot de passe", -1)
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "py-[15px] relative block" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "uppercase"
}, "Email", -1)
const _hoisted_9 = { class: "pt-[25px] relative block" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] bg-gray-50 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'resetPassword',
  setup(__props) {

const pageTitle = ref('Reset Password | IronSecur');
const router = useRouter();
onMounted(() => {
    document.title = pageTitle.value;
});

const email = ref('');
const loading = ref(false)
const errorMessage = ref('');
const successMessage = ref('')

const requestPasswordReset = async () => {
  try {
    loading.value = true;
    const response = await axiosInstance.post('/auth/users/reset_password/', {
      email: email.value
    });
    successMessage.value = 'Un mail comportant un lien de réinitialisation vous sera envoyé ! Cliquez sur le lien pour poursuivre le processus. Merci !!'
    setTimeout(() => {
      router.push('/login'); 
    }, 10000);
  } catch (error) {
    errorMessage.value = 'Erreur lors de la demande de réinitialisation';
    hideErrorMessageAfterDelay();
  } finally {
        loading.value = false; 
    }
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("form", {
          class: "relative w-full",
          onSubmit: _withModifiers(requestPasswordReset, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              type: "email",
              id: "email",
              class: "focus:border-gray-600 border p-[10px] border-gray-300 outline-none w-full",
              placeholder: "ironsecur@gmail.com"
            }, null, 512), [
              [_vModelText, email.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "p-[10px] bg-cyan-500 rounded-[5px] font-bold text-sm hover:bg-cyan-600 duration-100 cursor-pointer text-white outline-none w-full"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, "Suivant"))
            ], 8, _hoisted_10)
          ])
        ], 40, _hoisted_6)
      ])
    ]),
    _hoisted_13
  ], 64))
}
}

})